import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { InitialConfigType, LexicalComposer } from '@lexical/react/LexicalComposer';
import type { FC } from 'react';

import editorTheme from '../editorTheme';
import { ImageNode } from '../nodes';
import { EditorComposerProps } from './types';

const editorConfig: InitialConfigType = {
    namespace: 'editor',
    theme: editorTheme,
    onError(error: any) {
        throw error;
    },
    nodes: [ListNode, ListItemNode, AutoLinkNode, LinkNode, ImageNode]
};

export const EditorComposer: FC<EditorComposerProps> = ({ children, editorState, ...initialConfig }) => {
    const initialEditorState = typeof editorState === 'string' && editorState.length > 2 ? editorState : null;
    return (
        <LexicalComposer initialConfig={{ ...editorConfig, ...initialConfig, editorState: initialEditorState }}>{children}</LexicalComposer>
    );
};
